// extracted by mini-css-extract-plugin
module.exports = {"animate-height":"PageContainer_animate-height__1YVfZ","PageContainer":"PageContainer_PageContainer__3anM4","animateHeight":"PageContainer_animateHeight__11fyc"};